import UserPoolClientDetails from "./UserPoolClientDetails";

export default UserPoolClientDetails;